import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NavigationBar.css';

const NavigationBar = () => {
  const { t } = useTranslation();

  return (
    <nav className="nav-bar">
      <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>{t('home')}</NavLink>
      <NavLink to="/workout" className={({ isActive }) => isActive ? 'active' : ''}>{t('workout')}</NavLink>
      <NavLink to="/gym" className={({ isActive }) => isActive ? 'active' : ''}>{t('gym')}</NavLink>
      <NavLink to="/weight" className={({ isActive }) => isActive ? 'active' : ''}>{t('weight')}</NavLink>
      <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>{t('settings')}</NavLink>
    </nav>
  );
};

export default NavigationBar;